module.exports = "/assets/40603e2562baa48dbb7aaf9327a0be84.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ZK.png
// module id = 2067
// module chunks = 0